<template>
    <div class="gch-tv-container">
        <div class="gch-tv-header">
            <div class="gch-tv-logo-wrap">
                <img src="../feiraempreendedor/assets/logo-feira-empreendedor.svg" alt="Feira do Empreendedor 26" class="gch-tv-logo" />
            </div>
            <span class="gch-tv-titulo">Painel de Chamadas</span>
        </div>

        <div class="gch-tv-body">
            <!-- Chamada atual em destaque -->
            <div v-if="chamadaAtual" class="gch-tv-secao gch-tv-secao--principal">
                <div class="gch-tv-secao-rotulo">Chamando agora</div>
                <div :class="['gch-tv-card-chamada', 'gch-tv-card-chamada--principal', { 'gch-tv-card-destaque': destacar }]">
                    <div class="gch-tv-mesa">
                        <div class="gch-tv-mesa-rotulo">MESA</div>
                        <div class="gch-tv-mesa-numero">{{ chamadaAtual.guicheNumero }}</div>
                        <div class="gch-tv-espaco">{{ chamadaAtual.nomeEspaco }}</div>
                    </div>
                    <div class="gch-tv-meio">
                        <div class="gch-tv-nome">{{ anonimizar(chamadaAtual.nomeAnonimizado || chamadaAtual.nomeCliente) }}</div>
                    </div>
                    <div class="gch-tv-senha-bloco">
                        <div class="gch-tv-senha-rotulo">SENHA</div>
                        <div class="gch-tv-senha-valor">{{ chamadaAtual.senha }}</div>
                    </div>
                </div>
            </div>
            <div v-else class="gch-tv-vazio">Aguardando próxima chamada...</div>

            <!-- Historico no mesmo padrao da chamada principal, apenas menor -->
            <div v-if="historicoSemAtual.length" class="gch-tv-secao">
                <div class="gch-tv-secao-rotulo">Últimas chamadas</div>
                <div class="gch-tv-historico">
                    <div
                        v-for="item in historicoSemAtual"
                        :key="item.idAtendimento"
                        class="gch-tv-card-chamada gch-tv-card-chamada--historico"
                    >
                        <div class="gch-tv-mesa">
                            <div class="gch-tv-mesa-rotulo">MESA</div>
                            <div class="gch-tv-mesa-numero">{{ item.guicheNumero }}</div>
                            <div class="gch-tv-espaco">{{ item.nomeEspaco }}</div>
                        </div>
                        <div class="gch-tv-meio">
                            <div class="gch-tv-nome">{{ anonimizar(item.nomeAnonimizado || item.nomeCliente) }}</div>
                        </div>
                        <div class="gch-tv-senha-bloco">
                            <div class="gch-tv-senha-rotulo">SENHA</div>
                            <div class="gch-tv-senha-valor">{{ item.senha }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button v-if="mostrarBotaoFullscreen" class="gch-tv-fullscreen-btn" @click="entrarFullscreen">Entrar em tela cheia</button>
    </div>
</template>

<script>
import services from './services';

export default {
    name: 'GuichePainelTV',

    data() {
        return {
            historico: [],
            chamadaAtual: null,
            pollIntervalId: null,
            audioCtx: null,
            mostrarBotaoFullscreen: false,
            destacarTimerId: null,
            destacar: false,
            ultimoIdConhecido: null,
            inicializado: false,
        };
    },

    computed: {
        historicoSemAtual() {
            // Mantemos ate 3 historicos para nao competir visualmente com a chamada
            // principal, que agora ocupa todo o topo da TV.
            if (!this.chamadaAtual) return this.historico.slice(0, 3);
            return this.historico.filter((c) => c.idAtendimento !== this.chamadaAtual.idAtendimento).slice(0, 3);
        },
    },

    async mounted() {
        this.tentarFullscreen();
        await this.carregarUltimos();
        this.iniciarPolling();
    },

    beforeUnmount() {
        if (this.pollIntervalId) clearInterval(this.pollIntervalId);
        if (this.destacarTimerId) clearTimeout(this.destacarTimerId);
        if (this.audioCtx && this.audioCtx.state !== 'closed') {
            this.audioCtx.close().catch(() => {});
        }
    },

    methods: {
        async tentarFullscreen() {
            try {
                if (document.documentElement.requestFullscreen) {
                    await document.documentElement.requestFullscreen();
                    this.mostrarBotaoFullscreen = false;
                }
            } catch (e) {
                this.mostrarBotaoFullscreen = true;
            }
        },

        async entrarFullscreen() {
            try {
                await document.documentElement.requestFullscreen();
                this.mostrarBotaoFullscreen = false;
            } catch (e) {
                // ignora
            }
            this.desbloquearAudio();
        },

        desbloquearAudio() {
            try {
                if (!this.audioCtx) {
                    const Ctx = window.AudioContext || window.webkitAudioContext;
                    if (!Ctx) return;
                    this.audioCtx = new Ctx();
                }
                if (this.audioCtx.state === 'suspended') {
                    this.audioCtx.resume().catch(() => {});
                }
            } catch (e) {
                // silencioso
            }
        },

        async carregarUltimos() {
            const resp = await services.obterUltimosChamados(4);
            if (!resp?.success || !Array.isArray(resp.data)) return;

            const lista = resp.data;
            const primeiro = lista[0] || null;
            const ehNova = this.inicializado && primeiro && primeiro.idAtendimento !== this.ultimoIdConhecido;

            this.historico = lista;
            if (primeiro) this.chamadaAtual = primeiro;

            if (ehNova) {
                this.destacar = true;
                this.tocarDingDong();
                if (this.destacarTimerId) clearTimeout(this.destacarTimerId);
                this.destacarTimerId = setTimeout(() => {
                    this.destacar = false;
                }, 5000);
            }

            this.ultimoIdConhecido = primeiro ? primeiro.idAtendimento : null;
            this.inicializado = true;
        },

        anonimizar(nome) {
            if (!nome) return '';
            const partes = String(nome).trim().split(/\s+/).filter(Boolean);
            if (partes.length === 0) return '';
            const primeiro = partes[0];
            const iniciais = partes.slice(1).map((p) => p.charAt(0).toUpperCase() + '.').join(' ');
            return iniciais ? `${primeiro} ${iniciais}` : primeiro;
        },

        iniciarPolling() {
            this.pollIntervalId = setInterval(() => {
                this.carregarUltimos();
            }, 3000);
        },

        tocarDingDong() {
            try {
                if (!this.audioCtx) {
                    const Ctx = window.AudioContext || window.webkitAudioContext;
                    if (!Ctx) return;
                    this.audioCtx = new Ctx();
                }
                if (this.audioCtx.state === 'suspended') {
                    this.audioCtx.resume().catch(() => {});
                }
                const ctx = this.audioCtx;
                const tocarTom = (freq, inicio, duracao) => {
                    const osc = ctx.createOscillator();
                    const gain = ctx.createGain();
                    osc.type = 'sine';
                    osc.frequency.value = freq;
                    gain.gain.setValueAtTime(0.0001, ctx.currentTime + inicio);
                    gain.gain.exponentialRampToValueAtTime(0.5, ctx.currentTime + inicio + 0.02);
                    gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + inicio + duracao);
                    osc.connect(gain);
                    gain.connect(ctx.destination);
                    osc.start(ctx.currentTime + inicio);
                    osc.stop(ctx.currentTime + inicio + duracao + 0.05);
                };
                tocarTom(880, 0, 0.4);
                tocarTom(659, 0.42, 0.5);
            } catch (e) {
                // silencioso
            }
        },
    },
};
</script>

<style src="./guiche.css"></style>
